<template>
  <div>
    <h1>Login email</h1>

    <input
      class="form-control col-md-12"
      type="text"
      v-model="user.email"
      disabled
    >
    <p class="mt-5">
      Click
      <a href="#" @click="openModal">here</a>
      to change your password.
    </p>
    <forgot-pass-modal
      ref="resetPassModal"
      :email="user.email"
      @on-success="didResetPassword"
    />
  </div>
</template>
<script>

import ForgotPassModal from '@/components/auth/forgot_pass/ForgotPassModal';

export default {
  components: {
    ForgotPassModal,
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    openModal() {
      const rpModal = this.$refs.resetPassModal;
      rpModal.validateEmail();
      rpModal.show(false);
    },
    didResetPassword() {
      this.$notify({ group: 'alert', text: 'Password reset successfully.' });
      this.$refs.resetPassModal.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/tabs/change_password/ChangePasswordContent.vue